export const TEXT_KEYS = {
    LANDING_TITLE: 'login__login-title-text',
    LANDING_DESCRIPTION: 'login__login-description-text',
    LOGIN_BUTTON: 'login__login-button'
};
